module.exports = __webpack_public_path__ + "img/login-ifm.ccf5b013.png";